/* eslint-disable camelcase */
import { KueskiAttribution } from '@kueski-dev/web-observability';
import { GTMAttributionEntries, GTMAttributionParam, GTMAttributionValues } from './useUserActivity.types';

const ATTRIBUTION_PARAMS: GTMAttributionParam[] = [
  'fbclid',
  'gclid',
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
];

export const getGTMAttributionFromURL = (href: string) => {
  const url = new URL(href);
  const gtmAttribution = ATTRIBUTION_PARAMS.map(
    (name: GTMAttributionParam) => {
      const value = url.searchParams.get(name);
      if (!value) return false;
      return [name, value];
    },
  ).filter(Boolean) as GTMAttributionEntries;

  return Object.fromEntries(gtmAttribution) as GTMAttributionValues;
};

export const urlHasTrackingParams = (gtmAttribution: GTMAttributionValues) => (
  Object.keys(gtmAttribution).length > 0
);

export const extractAttributionParams = (target: KueskiAttribution) => (
  ATTRIBUTION_PARAMS.reduce(
    (attribution, name) => (
      name in target
        ? { ...attribution, [name]: target[name] }
        : attribution
    ),
    {} as Partial<KueskiAttribution>,
  )
);
